let accordion = {

    init: () => {

        accordion.accordion = document.querySelectorAll('.ce_accordion');

        if (accordion.accordion.length > 0) {
            accordion.run();
        }

        return accordion;
    },

    run: () => {

        const accordions = accordion.accordion;

        const openAccordion = (accordion) => {
            const content = accordion.querySelector(".accordion");
            accordion.classList.add("ce_accordion__active");
            content.style.maxHeight = content.scrollHeight + "px";
        };

        const closeAccordion = (accordion) => {
            const content = accordion.querySelector(".accordion");
            accordion.classList.remove("ce_accordion__active");
            content.style.maxHeight = null;
        };

        accordions.forEach((accordion) => {
            const intro = accordion.querySelector(".toggler");
            const content = accordion.querySelector(".accordion");

            intro.onclick = () => {
                if (content.style.maxHeight) {
                    closeAccordion(accordion);
                } else {
                    accordions.forEach((accordion) => closeAccordion(accordion));
                    openAccordion(accordion);
                }
            };
        });

    }

};

export default accordion.init();